import { cn } from '@bazaar-marketplace/utils';
import * as React from 'react';

function Input({ className, type, suffix, ...props }: React.ComponentProps<'input'> & { suffix?: string }) {
  return (
    <div className="relative flex items-center">
      <input
        className={cn(
          'h-14 focus:ring-0 placeholder:text-muted-foreground w-full min-w-0 rounded-2xl bg-[#FFFFFF0D] border border-[#D8BBFF] text-[#D8BBFF] px-3 py-1 text-base transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        data-slot="input"
        type={type}
        {...props}
      />
      <span className="text-sm text-muted-foreground absolute right-3 top-1/2 -translate-y-1/2">{suffix}</span>
    </div>
  );
}

export { Input };
